export default class FAQs {
	constructor(el) {

		this.faqs 			= el
		this.toggleTopic 	= this.toggleTopic.bind(this)
		this.toggleStudio 	= this.toggleStudio.bind(this)
		this.currentStudio 	= el.querySelector('[data-studio]') // get first studio

		// Get all studio buttons and studios
		this.studioButtons 	= [...this.faqs.querySelectorAll('[data-studiofilter]') ]
		this.allStudios 	= document.querySelectorAll('[data-studio]')

		// console.log(this.studioButtons);

		for (var i = 0; i < this.studioButtons.length; i++) {
			this.studioButtons[i].addEventListener('click', this.toggleStudio )
		}

		// Get all topic buttons within each studio and topics

		this.topicButtons 	= [...this.faqs.querySelectorAll('[data-topicfilter]') ]
		this.allTopics 		= document.querySelectorAll('[data-topic]')

		for (var i = 0; i < this.topicButtons.length; i++) {
			this.topicButtons[i].addEventListener('click', this.toggleTopic )
		}
		

	}

	toggleStudio(event) {

		const inx = this.studioButtons.indexOf(event.currentTarget)
		const button = this.studioButtons[inx]
		const studio = this.faqs.querySelector(`[data-studio="${button.dataset.studiofilter}"]`)


		if(button.dataset.studiofilter === this.currentStudio.dataset.studio){
			console.log('already open')
			return
		}


		if( button.ariaExpanded === 'false' ){
			button.setAttribute('aria-selected', 'true')
		} else {
			button.setAttribute('aria-selected', 'false')
		}

		if(studio){
			this.openTopic(studio)
			this.closeSiblingTabs(studio, this.allStudios)
			this.currentStudio = studio

			// First close all topics
			this.closeSiblingTabs(null, this.allTopics)
			
			// Then find and activate the first topic in this studio
			const firstTopicButton = studio.querySelector('[data-topicfilter]')
			const firstTopic = studio.querySelector('[data-topic]')
			if (firstTopicButton && firstTopic) {
				firstTopicButton.classList.add('active')
				firstTopicButton.setAttribute('aria-selected', 'true')
				firstTopic.removeAttribute('hidden')
				this.closeSiblingToggles(firstTopicButton,this.topicButtons)
			}
		}

		this.closeSiblingToggles(button, this.studioButtons)

	}
  
	toggleTopic(event) {

		const inx = this.topicButtons.indexOf(event.currentTarget)
		const button = this.topicButtons[inx]
		const topic = this.currentStudio.querySelector(`[data-topic="${button.dataset.topicfilter}"]`)

		// console.log(topic);

		if(button.classList.contains('active')){
			return
		}

		// OPEN CLICKED
		button.classList.toggle('active')

		if( button.ariaExpanded === 'false' ){
			button.setAttribute('aria-selected', 'true')
		} else {
			button.setAttribute('aria-selected', 'false')
		}

		if(topic){
			this.openTopic(topic)
			this.closeSiblingTabs(topic,this.allTopics)
		}

		this.closeSiblingToggles(button,this.topicButtons)

	}

	openTopic(tab) {

		if( tab.hidden === false ){
			tab.setAttribute('hidden', true)
		} else {
			tab.removeAttribute('hidden')
		}
	}

	closeSiblingTabs(exceptThis,siblings) {
		// This closes both studios and topics
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].setAttribute('hidden', true);
			}
		}
	}

	closeSiblingToggles(exceptThis,siblings) {
		for (var i = 0; i < siblings.length; i++) {
			if (siblings[i] !== exceptThis) {
				siblings[i].classList.remove('active');
			}
		}
	}
  
}
